import { Inject } from '@rxdi/core';
import { Component, html, LitElement, OnUpdate, property, queryAll, unsafeHTML } from '@rxdi/lit-html';

import { MarkdownParserService } from '../markdown-reader.service';
import { MarkdownParserMenuProvider } from '../markdown-reader-menu.provider';
import { style } from './markdown-reader.component.css';
/**
 * @customElement markdown-reader
 */
@Component({
  selector: 'markdown-reader',
  style,
  template(this: MarkdownReaderComponent) {
    return html` ${unsafeHTML(this.compileMarkdown(this.template))} `;
  },
})
export class MarkdownReaderComponent extends LitElement implements OnUpdate {
  @property() template: string;

  @Inject(MarkdownParserService)
  private mdParser: MarkdownParserService;

  @Inject(MarkdownParserMenuProvider)
  private mdParserMenu: MarkdownParserMenuProvider;

  @queryAll('code') private tags: NodeListOf<HTMLElement>[];

  OnUpdate() {
    this.mdParser.highlightElements(this.tags);
    this.mdParserMenu.lookupHeadings(this.shadowRoot);
  }

  compileMarkdown(template: string) {
    return this.mdParser.readAndCompile(template);
  }
}
